import React, { useContext, useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Grid, Tooltip, IconButton, Button, TextField, MenuItem, Link, List, ListItem, Typography, Autocomplete } from '@mui/material';
import { MdSave as SaveIcon, MdClose as CancelIcon } from 'react-icons/md';
import { ITeamMember, ticketDetailsContext } from '../../TicketDetailsContext';
import Moment from 'react-moment';
import { applicationContext, appUserContext } from 'helpers/services';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import moment from 'moment';
import { useHistory } from 'react-router';
import { DeleteIconButton, EditIconButton, SimecUser } from 'components';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import TeamSummary from './TeamSummary';


let Team = () => {
    let history = useHistory();
    let { formatMessage } = useIntl();

    let { currentUser, isMobile } = useContext(appUserContext);
    let appService = useContext(applicationContext);
    let service = useContext(ticketDetailsContext);

    const defaultTeam: ITeamMember = {
        userName: '',
        startDate: null,
        endDate: null,
        otherTickets: []
    }

    let [teamMember, setTeamMember] = useState<ITeamMember>(defaultTeam);

    let [editTeamMemberDates, setEditTeamMemberDates] = useState<number | null>(null);
    let [editTeamMember, setEditTeamMember] = useState<ITeamMember>({} as ITeamMember);

    let handleEditTeamMember = (index: number) => {
        setEditTeamMember(service.teamMembers[index]);
        setEditTeamMemberDates(index);
    }

    let handleChangeTeamMembers = async (teamMemberFormData: ITeamMember, index: number | null, action: 'add' | 'edit' | 'delete') => {
        let res = await service.handleChangeTeamMembers(teamMemberFormData, index, action);
        if (res === true) {
            setTeamMember(defaultTeam);
            setEditTeamMemberDates(null);
        }
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    {isMobile === false &&
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{formatMessage({ id: LocalizationIds.Name })}</TableCell>
                                    <TableCell>{formatMessage({ id: LocalizationIds.From })}</TableCell>
                                    <TableCell>{formatMessage({ id: LocalizationIds.To })}</TableCell>
                                    <TableCell>{formatMessage({ id: LocalizationIds.OtherTickets })}</TableCell>
                                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                                        <TableCell align="right"></TableCell>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {service.teamMembers.map((teamMember, index) =>
                                    <TableRow key={index}>
                                        <TableCell>
                                            <SimecUser username={teamMember.userName} />
                                        </TableCell>
                                        {editTeamMemberDates === index &&
                                            <>
                                                <TableCell>
                                                    <DesktopDatePicker
                                                        label={formatMessage({ id: LocalizationIds.DateFrom })}
                                                        value={editTeamMember.startDate}
                                                        onChange={(value) => setEditTeamMember({ ...editTeamMember, startDate: moment(value) })}
                                                        renderInput={props => <TextField {...props} size="small" />}
                                                        inputFormat="DD/MM/YYYY"
                                                        
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <DesktopDatePicker
                                                        label={formatMessage({ id: LocalizationIds.DateTo })}
                                                        value={editTeamMember.endDate}
                                                        onChange={(value) => setEditTeamMember({ ...editTeamMember, endDate: moment(value) })}
                                                        renderInput={props => <TextField {...props} size="small" />}
                                                        inputFormat="DD/MM/YYYY"
                                                        
                                                    />
                                                </TableCell>
                                            </>
                                        }
                                        {editTeamMemberDates !== index &&
                                            <>
                                                <TableCell>
                                                    {!teamMember.startDate && '-'}
                                                    {teamMember.startDate && <Moment date={teamMember.startDate} format="LL" />}
                                                </TableCell>
                                                <TableCell>
                                                    {!teamMember.endDate && '-'}
                                                    {teamMember.endDate && <Moment date={teamMember.endDate} format="LL" />}
                                                </TableCell>
                                            </>
                                        }
                                        <TableCell>
                                            {teamMember.otherTickets.length === 0 && '-'}

                                            {teamMember.otherTickets.map((otherTicket, index) =>
                                                <React.Fragment key={index}>
                                                    <Link component="button" onClick={() => { history.push(`/ticket/edit/${otherTicket.ticketNumber}`) }}>
                                                        {otherTicket.ticketNumber} - {otherTicket.title}
                                                    </Link>
                                                    {index < teamMember.otherTickets.length - 1 ? ', ' : ''}
                                                </React.Fragment>
                                            )}
                                        </TableCell>
                                        {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                                            <TableCell align="right">
                                                {editTeamMemberDates !== index &&
                                                    <>
                                                        <EditIconButton onClick={() => handleEditTeamMember(index)} />
                                                        <DeleteIconButton onClick={async () => await handleChangeTeamMembers(teamMember, index, 'delete')} />
                                                    </>
                                                }
                                                {editTeamMemberDates === index &&
                                                    <>
                                                        <Tooltip title={formatMessage({ id: LocalizationIds.SaveChanges })}>
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                onClick={async () => await handleChangeTeamMembers(editTeamMember, index, 'edit')}
                                                            >
                                                                <SaveIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={formatMessage({ id: LocalizationIds.Cancel })}>
                                                            <IconButton
                                                                size="small"
                                                                color="secondary"
                                                                onClick={() => setEditTeamMemberDates(null)}
                                                            >
                                                                <CancelIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                }
                                            </TableCell>
                                        }
                                    </TableRow>
                                )}
                                {service.teamMembers.length === 0 &&
                                    <TableRow>
                                        <TableCell colSpan={5}><i>{formatMessage({ id: LocalizationIds.NoResults })}</i></TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    }
                    {isMobile === true &&
                        <List>
                            {service.teamMembers.map((teamMember, index) =>
                                <ListItem disableGutters divider key={index}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant="body2">
                                                <b>{formatMessage({ id: LocalizationIds.Name })}:</b>&nbsp;
                                            </Typography>
                                            <SimecUser username={teamMember.userName} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body2">
                                                <b>{formatMessage({ id: LocalizationIds.From })}:</b>&nbsp;
                                            </Typography>
                                            {editTeamMemberDates === index &&
                                                <DesktopDatePicker
                                                    label={formatMessage({ id: LocalizationIds.DateFrom })}
                                                    value={editTeamMember.startDate}
                                                    onChange={(value) => setEditTeamMember({ ...editTeamMember, startDate: moment(value) })}
                                                    renderInput={props => <TextField {...props} size="small" />}
                                                    inputFormat="DD/MM/YYYY"
                                                    
                                                />
                                            }
                                            {editTeamMemberDates !== index &&
                                                <>
                                                    {!teamMember.startDate && '-'}
                                                    {teamMember.startDate && <Moment date={teamMember.startDate} format="LL" />}
                                                </>
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body2">
                                                <b>{formatMessage({ id: LocalizationIds.To })}:</b>&nbsp;
                                            </Typography>
                                            {editTeamMemberDates === index &&
                                                <DesktopDatePicker
                                                    label={formatMessage({ id: LocalizationIds.DateTo })}
                                                    value={editTeamMember.endDate}
                                                    onChange={(value) => setEditTeamMember({ ...editTeamMember, endDate: moment(value) })}
                                                    renderInput={props => <TextField {...props} size="small" />}
                                                    inputFormat="DD/MM/YYYY"
                                                    
                                                />
                                            }
                                            {editTeamMemberDates !== index &&
                                                <>
                                                    {!teamMember.endDate && '-'}
                                                    {teamMember.endDate && <Moment date={teamMember.endDate} format="LL" />}
                                                </>
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body2">
                                                <b>{formatMessage({ id: LocalizationIds.OtherTickets })}:</b>&nbsp;
                                            </Typography>
                                            {teamMember.otherTickets.length === 0 && '-'}

                                            {teamMember.otherTickets.map((otherTicket, index) =>
                                                <React.Fragment key={index}>
                                                    <Link component="button" onClick={() => { history.push(`/ticket/edit/${otherTicket.ticketNumber}`) }}>
                                                        {otherTicket.ticketNumber} - {otherTicket.title}
                                                    </Link>
                                                    {index < teamMember.otherTickets.length - 1 ? ', ' : ''}
                                                </React.Fragment>
                                            )}
                                        </Grid>
                                        {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                                {(editTeamMemberDates === null || editTeamMemberDates !== index) &&
                                                    <>
                                                        <EditIconButton onClick={() => handleEditTeamMember(index)} />
                                                        <DeleteIconButton onClick={async () => await handleChangeTeamMembers(teamMember, index, 'delete')} />
                                                    </>
                                                }
                                                {editTeamMemberDates === index &&
                                                    <>
                                                        <Tooltip title={formatMessage({ id: LocalizationIds.SaveChanges })}>
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                onClick={async () => await handleChangeTeamMembers(editTeamMember, index, 'edit')}
                                                            >
                                                                <SaveIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={formatMessage({ id: LocalizationIds.Cancel })}>
                                                            <IconButton
                                                                size="small"
                                                                color="secondary"
                                                                onClick={() => setEditTeamMemberDates(null)}
                                                            >
                                                                <CancelIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                }
                                            </Grid>
                                        }
                                    </Grid>
                                </ListItem>
                            )}
                        </List>
                    }
                </Grid>
                {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                    <>
                        <Grid item xs={12} md={true}>
                            <Autocomplete
                                value={teamMember.userName}
                                onChange={(e, newValue) => setTeamMember({ ...teamMember, userName: newValue || '' })}
                                isOptionEqualToValue={(option, value) => option === value}
                                getOptionLabel={(option) => appService.simecUsers.getValueByKey(option, 'email', 'fullName')}
                                options={appService.simecUsers.filter(x => x.simecClaims.canGoToCustomer === true).map(x => x.email)}
                                renderOption={(muiProps, option) => (
                                    <li {...muiProps}>
                                        {<>&nbsp;{appService.simecUsers.getValueByKey(option, 'email', 'fullName')}</>}
                                    </li>
                                )}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label={formatMessage({ id: LocalizationIds.ChooseTeamMember })}
                                    />
                                }
                            />
                        </Grid>
                        <DateRangePicker
                            startText={formatMessage({ id: LocalizationIds.DateFrom })}
                            endText={formatMessage({ id: LocalizationIds.DateTo })}
                            value={[teamMember.startDate, teamMember.endDate]}
                            onChange={(newValue: DateRange<Date>) => {
                                setTeamMember({
                                    ...teamMember,
                                    startDate: newValue != null ? moment(newValue[0]) : null,
                                    endDate: newValue != null ? moment(newValue[1]) : null
                                })
                            }}
                            renderInput={(startProps, endProps) => (
                                <>
                                    <Grid item xs={12} md={true}>
                                        <TextField {...startProps} />
                                    </Grid>
                                    <Grid item xs={12} md={true}>
                                        <TextField {...endProps} />
                                    </Grid>
                                </>
                            )}
                        />
                        <Grid item xs={12} md={true}>
                            <Button
                                variant="outlined"
                                onClick={async () => await handleChangeTeamMembers(teamMember, null, 'add')}
                            >
                                {formatMessage({ id: LocalizationIds.Confirm })}
                            </Button>
                        </Grid>
                    </>
                }
            </Grid>
            {service.teamReview.length > 0 &&
                <TeamSummary />
            }
        </>
    )
}

export default Team;